import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Item } from "@material-ui/core";

import "./Home.css";
import { APIKEY } from "../config.json";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  grid: {
    paddingTop: '7%',
    width: '60%',
  },
  item: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  }
}));

const messages = defineMessages({
  search_placeholder: {
    id: "home.search_placeholder",
    defaultMessage:
      "請輸入{type, select, " +
      " pnr {車格}" +
      " lpr {車牌}" +
      " other {??}" +
      "}號碼",
  },
  clear: {
    id: "home.clear",
    defaultMessage: "清除",
  },
});

function DigitKeyboard(props) { 
  const classes = useStyles();
  const history = useHistory();
  const intl = useIntl();
  const searchType = useSelector((state) => state.searchType);
  const apikey = useSelector((state) => state.apikey);
  const building_id = useSelector((state) => state.buildingId);
  const building_code = useSelector((state) => state.buildingCode);
  const [carNumber, setCarNumber] = useState("");
  const keyboardList = [
    { key: "1", name: "1", text: "1", className: "btn_1", src: "img/btn-1.png" },
    { key: "2", name: "2", text: "2", className: "btn_2", src: "img/btn-2.png" },
    { key: "3", name: "3", text: "3", className: "btn_3", src: "img/btn-3.png" },
    { key: "4", name: "4", text: "4", className: "btn_4", src: "img/btn-4.png" },
    { key: "5", name: "5", text: "5", className: "btn_5", src: "img/btn-5.png" },
    { key: "6", name: "6", text: "6", className: "btn_6", src: "img/btn-6.png" },
    { key: "7", name: "7", text: "7", className: "btn_7", src: "img/btn-7.png" },
    { key: "8", name: "8", text: "8", className: "btn_8", src: "img/btn-8.png" },
    { key: "9", name: "9", text: "9", className: "btn_9", src: "img/btn-9.png" },
    {
      key: "CLEAR",
      name: "CLEAR",
      text: intl.formatMessage(messages.clear),
      className: "btn_clear",
      src: "img/btn-clear.png"
    },
    { key: "0", name: "0", text: "0", className: "btn_0", src: "img/btn-0.png"},
  ];
  const pushButtonNumber = (button) => {
    var finalValue = carNumber;
    const numberStr = "0123456789";
    const num = button.key;
    if (num === "CLEAR") {
      finalValue = "";
    } else if (num === "X") {
      finalValue = carNumber.slice(0, -1);
    } else if (numberStr.includes(num)) {
      if (finalValue.length < 4) {
        finalValue = finalValue.concat(num);
      }
    }
    setCarNumber(finalValue);
  };
  const handleSubmit = () => {
    history.push("/carList", {
      carNumber: carNumber,
      type: searchType,
      apikey: apikey,
      building_id: building_id,
      building_code: building_code,
    });
  };
  return (
    <div className={classes.grid}>
        <input value={carNumber} className="Rectangle"/>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          {keyboardList.map((button) => {
            return (
              <Grid item
                xs={4}
                className={classes.item}
              >
                <img src={button.src}
                  alt={button.text}
                  onClick={() => {
                    pushButtonNumber(button);
                  }}
                  key={"buttonNum".concat(button.name)}
                  className={button.className}
                />
              </Grid>
              
            );
          })}
          <Grid item xs={4} className={classes.item}>
            <img
              src='img/btn-search.png'
              alt={"確認"}
              onClick={() => {
                handleSubmit();
              }}
              type="submit"
              className="btn_search"
            />
            </Grid>
          </Grid>
    </div>
  );
}

function Home(props) {
  const classes = useStyles();
  const intl = useIntl();
  const searchType = useSelector((state) => state.searchType);

  return (
    <div className={classes.root}>
        <span className="titletext">{intl.formatMessage(messages.search_placeholder, {type: searchType})}</span>
        <DigitKeyboard />
    </div>
  );
}

export default Home;
